import * as React from 'react';

var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
var SvgLockMid = function SvgLockMid(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7 7.25C7 4.48858 9.23858 2.25 12 2.25C14.7614 2.25 17 4.48858 17 7.25V9H17.25C18.7688 9 20 10.2312 20 11.75V19.25C20 20.7688 18.7688 22 17.25 22H6.75C5.23122 22 4 20.7688 4 19.25V11.75C4 10.2312 5.23122 9 6.75 9H7V7.25ZM6.75 10.5C6.05964 10.5 5.5 11.0596 5.5 11.75V19.25C5.5 19.9404 6.05964 20.5 6.75 20.5H17.25C17.9404 20.5 18.5 19.9404 18.5 19.25V11.75C18.5 11.0596 17.9404 10.5 17.25 10.5H6.75ZM15.5 9H8.5V7.25C8.5 5.317 10.067 3.75 12 3.75C13.933 3.75 15.5 5.317 15.5 7.25V9ZM12 13.25C12.4142 13.25 12.75 13.5858 12.75 14V17C12.75 17.4142 12.4142 17.75 12 17.75C11.5858 17.75 11.25 17.4142 11.25 17V14C11.25 13.5858 11.5858 13.25 12 13.25Z"
  })));
};

export { SvgLockMid as ReactComponent };
//# sourceMappingURL=lock-mid.svg.js.map
